<template>
  <div class="div-main">
    <label v-if="title">
      <span class="title">{{ title }}</span>
      <span class="required" v-if="required">*</span>
      <Tip :field="field" :formName="formName" />
    </label>
    <div class="inner-addon right-addon">
      <i v-if="notifications.length > 0 && formDirty" class="required glyphicon fas fa-exclamation-triangle"></i>
      <vue-editor v-model.trim="value" :editorToolbar="customToolbar" :disabled="disabled"
        :class="{ disabled: disabled }"></vue-editor>
    </div>

    <div v-if="formDirty">
      <div v-for="message in notifications" :key="message">
        <span class="invalid">{{ message }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import Tip from "../shared/Tip.vue";
import { VueEditor } from "vue2-editor";

import { mapState, mapMutations } from "vuex";

export default {
  components: { Tip, VueEditor },
  name: "EditorHtml",
  mixins: [],
  props: {
    title: String,
    field: String,
    formName: String,
    required: Boolean,
    disabled: Boolean,
    maxLength: Number,
    value: String,
  },
  data() {
    return {
      notifications: [],
      formDirty: false,
      textoEditor: "",
      customToolbar: [["bold", "italic", "underline"]],
    };
  },
  created() {
    this.validate();
  },
  methods: {
    ...mapMutations("validation", [
      "addValidation",
      "removeValidation",
      "updateFormDirty",
    ]),
    validate() {
      this.notifications = [];

      if (this.required && this.value.length == 0) {
        var message = `${this.title} não pode ser vazio!`;
        this.notifications.push(message);
      }

      if (this.maxLength > 0) {
        if (this.value.length > this.maxLength) {
          var message = `Máximo de ${this.maxLength} caracteres!`;
          this.notifications.push(message);
        }
      }
    },
  },
  computed: {
    ...mapState("validation", ["resetForm", "validations"]),
  },
  watch: {
    value() {
      this.validate();
      this.formDirty = true;
      this.$emit("input", this.value);
      this.updateFormDirty(true);
    },
    notifications() {
      let self = this;
      this.notifications.forEach(function (notification) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
          notification: notification,
        };
        self.addValidation(obj);
      });

      if (this.notifications.length == 0) {
        let obj = {
          key: self.field + "&" + self.formName,
          formName: self.formName,
        };
        self.removeValidation(obj);
      }
    },
    resetForm: {
      handler(form) {
        if (form.name == this.formName) this.formDirty = false;
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
.div-main {
  margin-top: 10px;
  margin-bottom: 10px;
}

.success {
  color: #94aa2a;
  font-size: 14px;
}

.invalid {
  color: #f0134d;
  font-size: 14px;
}

.disabled {
  color: #86929e;
}
</style>
